(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5700],{

/***/ 62906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$8": function() { return /* binding */ GatedContentProvider; },
/* harmony export */   "v4": function() { return /* binding */ useGatedContent; }
/* harmony export */ });
/* unused harmony export GatedContentContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* eslint-disable @typescript-eslint/no-empty-function */

var GatedContentContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  showContent: false,
  updateRegistered: function updateRegistered() {}
});
var GatedContentProvider = GatedContentContext.Provider;
var useGatedContent = function useGatedContent() {
  var gatedContent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(GatedContentContext);

  if (!gatedContent) {
    throw new Error("Gated content isn't available. Please set it via GatedContentContext component.");
  }

  return gatedContent;
};

/***/ }),

/***/ 33903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sign_up; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/foundations/Theme/index.ts + 30 modules
var Theme = __webpack_require__(46630);
// EXTERNAL MODULE: ./src/views/GrowthMasters/components/Layout/Layout.tsx + 5 modules
var Layout = __webpack_require__(63946);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(51585);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
// EXTERNAL MODULE: ../../libs/matcha/components/Loader/index.ts
var Loader = __webpack_require__(37438);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/templates/Forms/GetAccessForm/index.ts + 2 modules
var GetAccessForm = __webpack_require__(44687);
// EXTERNAL MODULE: ../../libs/api/staticSiteBackend/segmentProfilesApi.ts
var segmentProfilesApi = __webpack_require__(33219);
// EXTERNAL MODULE: ./src/views/GrowthMasters/helper/verifyUserHasAccess.ts
var verifyUserHasAccess = __webpack_require__(77532);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/SignUpPage/Form/Form.tsx




function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var copy = {
  heading: "Get started with Growth Masters",
  description: "Sharpen your PM skills, be inspired by experts and learn from your peers. Sign up to receive full access to lessons, resources and live events."
};

var Form = function Form() {
  var _useState = (0,react.useState)(false),
      isLoading = _useState[0],
      setLoading = _useState[1];

  var router = (0,next_router.useRouter)();

  var handleSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
      var controller;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true); // Send and save profile cookie.

              controller = new AbortController();
              _context.next = 4;
              return (0,segmentProfilesApi/* fetchProfileCookie */.Oc)(controller.signal, data.email);

            case 4:
              setTimeout(function () {
                var page = router.query.page;

                if (page) {
                  router.push("/growth-masters/".concat(page, "/"));
                } else {
                  router.push("/growth-masters/");
                }
              }, 1500);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSection, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h1",
            variant: "h2",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "h2",
            variant: "pLarge",
            children: copy.description
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormWrapper, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GetAccessForm/* default */.Z, {
            onSubmit: function onSubmit(data) {
              return (0,verifyUserHasAccess/* verifyUserHasAccess */.t)(data);
            },
            onSuccess: function onSuccess(data) {
              return handleSubmit(data);
            },
            customFormIdentifier: "growth-masters-signup"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, {
            children: isLoading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLoader, {
              initial: {
                opacity: 0
              },
              animate: {
                opacity: 1
              },
              transition: {
                duration: 0.5,
                ease: "easeOut"
              },
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loader/* default */.Z, {})
            })
          })]
        })]
      })
    })
  });
};

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ebhmtk03"
} : 0)("max-width:880px;margin:0 auto;", Section/* Wrapper */.im, "{padding-top:20px;padding-bottom:100px;gap:0;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{padding-bottom:60px;}}" + ( true ? "" : 0));

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebhmtk02"
} : 0)("padding-top:80px;background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebhmtk01"
} : 0)( true ? {
  name: "ojxvwq",
  styles: "max-width:420px;min-height:440px;margin:0 auto;padding-top:40px;display:flex;align-items:flex-start;form{p{text-align:center;}}"
} : 0);

var StyledLoader = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "ebhmtk00"
} : 0)( true ? "" : 0);

/* harmony default export */ var Form_Form = (Form);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/SignUpPage/SignUp.tsx







var SignUp = function SignUp() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Layout/* default */.Z, {
    subnav: false,
    pageName: "Sign up",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_browser_esm/* Global */.xB, {
      styles: Globals
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Form_Form, {})]
  });
};

var Globals = /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("html{background-color:", Theme/* default.palette.twilio.gray.10 */.ZP.palette.twilio.gray[10], ";}" + ( true ? "" : 0),  true ? "" : 0);
/* harmony default export */ var SignUpPage_SignUp = (SignUp);
// EXTERNAL MODULE: ./src/views/GrowthMasters/components/RedirectToHome/RedirectToHome.tsx
var RedirectToHome = __webpack_require__(90696);
// EXTERNAL MODULE: ./src/views/GrowthMasters/hooks/useInitialCookie.tsx
var useInitialCookie = __webpack_require__(86052);
;// CONCATENATED MODULE: ./src/pages/growth-masters/sign-up/index.tsx






var sign_up_SignUp = function SignUp() {
  var _useInitialCookie = (0,useInitialCookie/* default */.Z)(),
      _useInitialCookie2 = (0,slicedToArray/* default */.Z)(_useInitialCookie, 2),
      show = _useInitialCookie2[0],
      isLoading = _useInitialCookie2[1];

  return show ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RedirectToHome/* default */.Z, {}) : isLoading ? null : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignUpPage_SignUp, {});
};

/* harmony default export */ var sign_up = (sign_up_SignUp);

/***/ }),

/***/ 63946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout_Layout; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/templates/FooterCompact/index.ts + 2 modules
var FooterCompact = __webpack_require__(69524);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../libs/matcha/components/Media/index.ts + 2 modules
var Media = __webpack_require__(75091);
// EXTERNAL MODULE: ./src/contexts/gatedContent.ts
var gatedContent = __webpack_require__(62906);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/index.ts + 3 modules
var UtilityNav = __webpack_require__(90629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/index.ts + 30 modules
var Navigation_MobileNavigation = __webpack_require__(86943);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/index.ts + 8 modules
var Navbar = __webpack_require__(90806);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/components/Navigation/MobileNavigation.tsx








var MobileNavigation = function MobileNavigation(_ref) {
  var announcement = _ref.announcement,
      demoButton = _ref.demoButton,
      after = _ref.after;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_MobileNavigation/* default */.ZP, {
    children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UtilityNav/* default */.Z, {
      announcement: announcement
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_MobileNavigation/* Navbar */.wp, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar/* Brand */.H2, {
        href: "/",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
        color: "primary",
        size: "medium",
        variant: "filled",
        expanded: true,
        href: demoButton.url,
        children: demoButton.text
      })]
    }), after]
  });
};

/* harmony default export */ var components_Navigation_MobileNavigation = (MobileNavigation);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/index.ts + 14 modules
var DesktopNavigation_Navbar = __webpack_require__(77966);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/index.ts + 24 modules
var Navigation_DesktopNavigation = __webpack_require__(82680);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/components/Navigation/DesktopNavigation.tsx







var DesktopNavigation = function DesktopNavigation(_ref) {
  var announcement = _ref.announcement,
      demoButton = _ref.demoButton,
      after = _ref.after;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_DesktopNavigation/* default */.ZP, {
    children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* UtilityNav */.T8, {
      announcement: announcement
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_DesktopNavigation/* Navbar */.wp, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation_Navbar/* Brand */.H2, {
        href: "/",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation_Navbar/* Aside */.xN, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          color: "primary",
          size: "medium",
          variant: "filled",
          href: demoButton.url,
          children: demoButton.text
        })
      })]
    }), after]
  });
};

/* harmony default export */ var components_Navigation_DesktopNavigation = (DesktopNavigation);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/components/Navigation/NavigationBrandGrowthMasters.tsx












var NavigationBrandGrowthMasters = function NavigationBrandGrowthMasters(_ref) {
  var announcement = _ref.announcement,
      after = _ref.after;

  var _usePageConfig = (0,page/* usePageConfig */.Gm)(),
      basePath = _usePageConfig.basePath;

  var _useGatedContent = (0,gatedContent/* useGatedContent */.v4)(),
      showContent = _useGatedContent.showContent;

  var router = (0,next_router.useRouter)();
  var demoButton = (0,react.useMemo)(function () {
    var copy = {
      text: "",
      url: ""
    };

    if (showContent || router.pathname.includes("sign-up")) {
      copy.text = "Grow with Segment";
      copy.url = (0,getAbsoluteUrl/* default */.Z)("/demo/", {
        baseUrl: "https://segment.com",
        basePath: ""
      });
    } else {
      copy.text = "Sign up";
      copy.url = "".concat(basePath, "/growth-masters/sign-up/");
    }

    return copy;
  }, [showContent, basePath, router]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      lessThan: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Navigation_MobileNavigation, {
        demoButton: demoButton,
        announcement: announcement,
        after: after
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      greaterThanOrEqual: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Navigation_DesktopNavigation, {
        demoButton: demoButton,
        announcement: announcement,
        after: after
      })
    })]
  });
};

/* harmony default export */ var Navigation_NavigationBrandGrowthMasters = (NavigationBrandGrowthMasters);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Subnav/index.ts + 20 modules
var Subnav = __webpack_require__(49833);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/components/Subnavigation/data.ts


var data = function data(pageConfig) {
  return [{
    label: "Home",
    id: "growth-masters-home",
    href: (0,getAbsoluteUrl/* default */.Z)("/growth-masters/", pageConfig)
  }, {
    label: "Curriculum",
    id: "curriculum",
    href: (0,getAbsoluteUrl/* default */.Z)("/growth-masters/curriculum/", pageConfig)
  }, {
    label: "Speakers",
    id: "speakers",
    href: (0,getAbsoluteUrl/* default */.Z)("/growth-masters/speakers/", pageConfig)
  }, {
    label: "Contact",
    id: "contact",
    href: (0,getAbsoluteUrl/* default */.Z)("/contact/", {
      baseUrl: "https://segment.com",
      basePath: ""
    })
  }];
};

/* harmony default export */ var Subnavigation_data = (data);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/components/Subnavigation/Subnavigation.tsx




var copy = {
  title: "Growth Masters"
};

var Subnavigation = function Subnavigation() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnav/* default */.Z, {
    "aria-label": copy.title,
    label: copy.title,
    children: Subnavigation_data(pageConfig).map(function (item) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnav/* Item */.c, {
        label: item.label,
        href: item.href
      }, item.label);
    })
  });
};

/* harmony default export */ var Subnavigation_Subnavigation = (Subnavigation);
// EXTERNAL MODULE: ./src/views/GrowthMasters/components/Layout/assets/OgGrowthMasters.png
var OgGrowthMasters = __webpack_require__(60777);
var OgGrowthMasters_default = /*#__PURE__*/__webpack_require__.n(OgGrowthMasters);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/components/Layout/Layout.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












// GrowthMasters pages are hosted on the different domain then the rest of the app
// so we don't want to use an absolute urls for the links
var customPageConfig = {
  baseUrl: ""
};

var Layout = function Layout(_ref) {
  var _ref$subnav = _ref.subnav,
      subnav = _ref$subnav === void 0 ? true : _ref$subnav,
      _ref$pageName = _ref.pageName,
      pageName = _ref$pageName === void 0 ? "" : _ref$pageName,
      children = _ref.children;
  var defaultPageConfig = (0,page/* usePageConfig */.Gm)();

  var pageConfig = _objectSpread(_objectSpread({}, defaultPageConfig), customPageConfig);

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page/* PageConfigProvider */.i$, {
    value: pageConfig,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: "twilioLight",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
        pageTitle: "Growth Masters".concat(pageName && " - ".concat(pageName), " | Twilio Segment"),
        pageOG: (OgGrowthMasters_default()),
        pageDescription: "Our culture of close internal alignment, constant communication, and shared incentives delivers sourcing, information, and due diligence advantages to our partners.",
        themeColor: theme.palette.twilio.gray[10],
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_NavigationBrandGrowthMasters, {
          after: subnav && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnavigation_Subnavigation, {})
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
          children: [children, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WrapperDivider, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {})
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterCompact/* default */.Z, {})]
      })
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "ekuscdy2"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var WrapperDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ekuscdy1"
} : 0)("padding:10px 40px 0;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{padding:10px 80px 0;}" + ( true ? "" : 0));

var StyledDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Divider/* default */.Z,  true ? {
  target: "ekuscdy0"
} : 0)("margin:0 auto;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:1280px;}" + ( true ? "" : 0));

/* harmony default export */ var Layout_Layout = (Layout);

/***/ }),

/***/ 90696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);



var RedirectToHome = function RedirectToHome() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    router.push("/growth-masters/");
  }, [router]);
  return null;
};

/* harmony default export */ __webpack_exports__["Z"] = (RedirectToHome);

/***/ }),

/***/ 77532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ verifyUserHasAccess; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20406);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28526);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _segment_api_staticSiteBackend_segmentProfilesApi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33219);



var verifyUserHasAccess = /*#__PURE__*/function () {
  var _ref = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
    var controller, response;
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(data.name || data.companyJobTitle)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", Promise.resolve(true));

          case 2:
            _context.prev = 2;
            controller = new AbortController(); // Fetching data from Profiles API to check if user
            // has any `get access` event associated to it

            _context.next = 6;
            return (0,_segment_api_staticSiteBackend_segmentProfilesApi__WEBPACK_IMPORTED_MODULE_1__/* .fetchUserRegisteredByEmail */ .WF)(controller.signal, {
              eventName: "Program Signup",
              formId: "growth-masters-signup",
              email: data.email
            });

          case 6:
            response = _context.sent;
            return _context.abrupt("return", Promise.resolve(Boolean(response.properties.email)));

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](2);

          case 12:
            return _context.abrupt("return", Promise.resolve(false));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 10]]);
  }));

  return function verifyUserHasAccess(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 86052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81333);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60266);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _segment_api_staticSiteBackend_segmentProfilesApi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33219);





var useInitialCookie = function useInitialCookie() {
  var _useCookie = (0,react_use__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_segment_api_staticSiteBackend_segmentProfilesApi__WEBPACK_IMPORTED_MODULE_1__/* .USER_PROFILE_COOKIE */ .TD),
      _useCookie2 = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useCookie, 1),
      profileCookie = _useCookie2[0];

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
      isLoading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      ungate = _useState2[0],
      setUngate = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setUngate(Boolean(profileCookie));
    setLoading(false);
  }, [profileCookie]);
  return [ungate, isLoading, setUngate];
};

/* harmony default export */ __webpack_exports__["Z"] = (useInitialCookie);

/***/ }),

/***/ 33219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Oc": function() { return /* binding */ fetchProfileCookie; },
/* harmony export */   "TD": function() { return /* binding */ USER_PROFILE_COOKIE; },
/* harmony export */   "WF": function() { return /* binding */ fetchUserRegisteredByEmail; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20406);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28526);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _segment_tracking_scripts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17397);
/* harmony import */ var _tracking_scripts_cookies__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16297);




var USER_PROFILE_COOKIE = "user-profile-enabled";
var fetchUserRegisteredByEmail = /*#__PURE__*/function () {
  var _ref = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(signal, options) {
    var eventName, formId, email, response;
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            eventName = options.eventName, formId = options.formId, email = options.email;
            _context.next = 3;
            return fetch("".concat((0,_segment_tracking_scripts__WEBPACK_IMPORTED_MODULE_1__/* .getBackendHost */ .kI)(window.location.host, window.location.protocol), "/backend/profile/").concat(eventName, "/").concat(formId), {
              method: "POST",
              headers: {
                'Content-Type': "application/json"
              },
              body: JSON.stringify({
                email: email
              }),
              signal: signal
            }).then(function (res) {
              return res.json();
            })["catch"](function (err) {
              return err.message;
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchUserRegisteredByEmail(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Decided to not check the endpoint or even the cookie value at this time.
 * The content is public anyways, however if we decide to `gate` the content we will need to make
 * this a HTTP cookie and control all data coming form /backend using this cookie.
 * Right now this function is just creating a cookie in the BE to be read in the FE through `useCookie`
 * @param email user email
 * @returns success or error message from server
 */

var fetchProfileCookie = /*#__PURE__*/function () {
  var _ref2 = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(signal, email) {
    var successMessage, errorMessage, jwt;
    return _workdir_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            successMessage = "user logged in";
            errorMessage = "user not logged in";

            if (!(0,_tracking_scripts_cookies__WEBPACK_IMPORTED_MODULE_2__/* .getCookie */ .ej)(USER_PROFILE_COOKIE)) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", successMessage);

          case 4:
            _context2.next = 6;
            return fetch("".concat((0,_segment_tracking_scripts__WEBPACK_IMPORTED_MODULE_1__/* .getBackendHost */ .kI)(window.location.host, window.location.protocol), "/backend/profile/auth"), {
              method: "POST",
              headers: {
                'Content-Type': "application/json"
              },
              body: JSON.stringify({
                email: email
              }),
              signal: signal
            }).then(function (res) {
              return res.json();
            })["catch"](function () {
              return errorMessage;
            });

          case 6:
            jwt = _context2.sent;
            return _context2.abrupt("return", jwt.message || "");

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchProfileCookie(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ 33445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.z; },
/* harmony export */   "l": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.l; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62073);


/***/ }),

/***/ 4203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Image; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ../../libs/matcha/components/Image/Image.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)((image_default()),  true ? {
  target: "eulst6f0"
} : 0)( true ? {
  name: "11726p1",
  styles: "height:auto;position:relative;margin:0 auto;display:block"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Image/Image.tsx


var _excluded = ["src", "alt", "width", "height", "unoptimized", "loader"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var imageLoader = function imageLoader(_ref) {
  var src = _ref.src;
  return "".concat(src);
};

var Image = function Image(_ref2) {
  var src = _ref2.src,
      alt = _ref2.alt,
      width = _ref2.width,
      height = _ref2.height,
      _ref2$unoptimized = _ref2.unoptimized,
      unoptimized = _ref2$unoptimized === void 0 ? true : _ref2$unoptimized,
      loader = _ref2.loader,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, _objectSpread(_objectSpread({
    loader: loader || imageLoader,
    width: width,
    height: height,
    src: src,
    alt: alt
  }, props), {}, {
    unoptimized: loader ? false : unoptimized
  }));
};
;// CONCATENATED MODULE: ../../libs/matcha/components/Image/index.ts


/***/ }),

/***/ 9642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _segment_tracking_scripts_cookies__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16297);



var useTrustArcLink = function useTrustArcLink() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      trustArcEnabled = _useState[0],
      setTrustArcEnabled = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var wt = window;

    if (wt.truste) {
      var consent = (0,_segment_tracking_scripts_cookies__WEBPACK_IMPORTED_MODULE_1__/* .getCookie */ .ej)("notice_behavior");

      if (consent !== "none") {
        setTrustArcEnabled(true);
      }
    }
  }, []);
  return trustArcEnabled;
};

/* harmony default export */ __webpack_exports__["Z"] = (useTrustArcLink);

/***/ }),

/***/ 90629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UtilityNav_UtilityNav; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/useUtilityNavDescriptions.tsx




var useUtilityNavDescriptions = function useUtilityNavDescriptions(descriptions) {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var keys = (0,react.useMemo)(function () {
    if (!descriptions) return [];
    return Object.keys(descriptions);
  }, [descriptions]);
  var breakpointsKeys = Object.keys(theme.breakpoints.values);
  var sortedArrayOfKeys = (0,react.useMemo)(function () {
    return breakpointsKeys.filter(function (main) {
      return keys.some(function (key) {
        return key === main;
      });
    });
  }, [breakpointsKeys, keys]);

  var getNextKey = function getNextKey(key, index) {
    if (sortedArrayOfKeys[index - 1]) {
      var getIndexofCurrentKey = breakpointsKeys.indexOf(key);

      if (breakpointsKeys[getIndexofCurrentKey - 1] !== sortedArrayOfKeys[index - 1]) {
        return breakpointsKeys[breakpointsKeys.indexOf(key) - 1];
      }
    }

    return false;
  };

  var array = sortedArrayOfKeys.map(function (key, index) {
    var nextKey = getNextKey(key, index);
    var minWidth = sortedArrayOfKeys[index - 1] ? " and ".concat(theme.breakpoints.up(nextKey ? nextKey : key, false)) : "";
    var mediaString = "".concat(theme.breakpoints.down(key, false)).concat(minWidth);
    return (0,useMatchMedia/* default */.Z)(mediaString, true);
  });
  return descriptions[sortedArrayOfKeys[array.indexOf(true)]];
};

/* harmony default export */ var UtilityNav_useUtilityNavDescriptions = (useUtilityNavDescriptions);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/UtilityNav.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e12rge5s2"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
var StyledButtonText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e12rge5s1"
} : 0)("padding-top:3px;margin:0 8px;font-size:", function (_ref) {
  var theme = _ref.theme;
  return theme.typography.buttonSmall;
}, ";&:after{height:1px;bottom:4px;}" + ( true ? "" : 0));
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e12rge5s0"
} : 0)("width:100%;text-align:center;background:", function (_ref2) {
  var background = _ref2.background;
  return background;
}, ";padding:7px 17px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("xs");
}, "{padding:17px 40px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/UtilityNav.tsx


var _excluded = ["announcement", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var UtilityNavBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var announcement = _ref.announcement,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var utilityNavDescriptions = "";

  if (typeof (announcement === null || announcement === void 0 ? void 0 : announcement.description) === "string") {
    utilityNavDescriptions = announcement.description;
  } else if (announcement !== null && announcement !== void 0 && announcement.description) {
    utilityNavDescriptions = UtilityNav_useUtilityNavDescriptions(announcement.description);
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    background: tokens.background,
    children: [utilityNavDescriptions && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
      variant: "buttonSmall",
      children: utilityNavDescriptions
    }), announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonText, {
      tokens: _objectSpread({}, tokens.buttonText),
      size: "small",
      href: announcement.ctaLink,
      hover: true,
      children: announcement.ctaTitle
    })]
  }));
});
var UtilityNav = (0,useDesignTokens/* withDesignTokens */.Y)(UtilityNavBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  light: function light(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  dark: function dark(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  }
});
/* harmony default export */ var UtilityNav_UtilityNav = (UtilityNav);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/index.ts


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 44687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ GetAccessForm; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/v1.js
var v1 = __webpack_require__(43833);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 22 modules
var FormFields = __webpack_require__(53790);
// EXTERNAL MODULE: ../../libs/templates/Disclaimer/index.ts + 3 modules
var Disclaimer = __webpack_require__(80401);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/FormFields/CompanyJobTitle.tsx
var CompanyJobTitle = __webpack_require__(10852);
// EXTERNAL MODULE: ../../libs/templates/FormFields/FullName.tsx
var FullName = __webpack_require__(43352);
// EXTERNAL MODULE: ../../libs/templates/FormFields/CompanyEmail.tsx
var CompanyEmail = __webpack_require__(12459);
// EXTERNAL MODULE: ../../libs/tracking/scripts/helpers.ts
var helpers = __webpack_require__(753);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../libs/utils/regexes/sharedEmail.ts
var sharedEmail = __webpack_require__(13206);
// EXTERNAL MODULE: ../../libs/utils/regexes/email.ts
var email = __webpack_require__(36219);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
;// CONCATENATED MODULE: ../../libs/templates/Forms/GetAccessForm/GetAccessForm.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eohuevw3"
} : 0)( true ? {
  name: "1flj9lk",
  styles: "text-align:left"
} : 0);
var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("form",  true ? {
  target: "eohuevw2"
} : 0)( true ? {
  name: "1bmvmcg",
  styles: "margin:0;width:100%"
} : 0);
var FormContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eohuevw1"
} : 0)( true ? {
  name: "r1rbwc",
  styles: "margin:0;display:grid;justify-items:stretch;gap:32px"
} : 0);
var StyledButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "eohuevw0"
} : 0)( true ? {
  name: "3418yg",
  styles: "align-items:center;min-height:56px;padding-top:14px;padding-bottom:13px"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Forms/GetAccessForm/GetAccessForm.tsx



var _excluded = ["appearance", "className", "customFormIdentifier", "customTrackingType", "overrideConsent", "onSubmit", "onSuccess"];


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




















var BUTTON_TEXT = "Get Access";
var errorMessage = {
  heading: "Something happened",
  description: "We are really sorry. There was an error processing your submission. Try reloading your browser, and submitting again."
};
/* eslint-disable camelcase */

var schema = lib/* object */.Ry({
  companyJobTitle: lib/* string */.Z_({
    required_error: CompanyJobTitle/* companyJobTitleMessages.required */.CZ.required
  }).regex(regexes_form/* default */.Z, {
    message: CompanyJobTitle/* companyJobTitleMessages.invalid */.CZ.invalid
  }),
  name: lib/* string */.Z_({
    required_error: FullName/* fullNameMessages.required */.a.required
  }).regex(regexes_form/* default */.Z, {
    message: FullName/* fullNameMessages.invalid */.a.invalid
  }),
  email: lib/* string */.Z_({
    required_error: CompanyEmail/* companyEmailMessages.required */.B.required
  }).regex(email/* default */.Z, {
    message: CompanyEmail/* companyEmailMessages.invalid */.B.invalid
  }).regex(sharedEmail/* default */.C, {
    message: CompanyEmail/* companyEmailMessages.sharedEmail */.B.sharedEmail
  })
}).partial({
  name: true,
  companyJobTitle: true
});
/* eslint-enable camelcase */
// Set up demo form props since we define some of these props here in the template

var GetAccessForm = function GetAccessForm(_ref) {
  var _methods$formState$er3, _methods$formState$er4, _methods$formState$er5, _methods$formState$er6;

  var appearance = _ref.appearance,
      className = _ref.className,
      customFormIdentifier = _ref.customFormIdentifier,
      customTrackingType = _ref.customTrackingType,
      overrideConsent = _ref.overrideConsent,
      onSubmit = _ref.onSubmit,
      onSuccess = _ref.onSuccess,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance); // Initialize form methods.

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
    resolver: (0,zod/* zodResolver */.F)(schema)
  });

  var _useState = (0,react.useState)(false),
      needsAccess = _useState[0],
      setNeedsAccess = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isLoading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react.useState)(""),
      prevEmail = _useState3[0],
      setPrevEmail = _useState3[1];

  var watchEmail = methods.watch("email");
  (0,react.useEffect)(function () {
    if (methods && needsAccess) {
      if (watchEmail === prevEmail) {
        methods.setFocus("name");
      } else {
        methods.setFocus("email");
        setNeedsAccess(false);
      }
    }
  }, [methods, needsAccess, prevEmail, watchEmail]);

  var submitCallback = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
      var _methods$formState$er, _methods$formState$er2;

      var uniqueId, result;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              uniqueId = (0,v1/* default */.Z)();
              _context.prev = 1;
              _context.next = 4;
              return (0,helpers/* identify */.yV)(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, data), customFormIdentifier && {
                customFormIdentifier: customFormIdentifier
              }), customTrackingType && {
                customTrackingType: customTrackingType
              }), {}, {
                server_message_id: uniqueId // eslint-disable-line camelcase

              }), overrideConsent);

            case 4:
              _context.next = 10;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](1);
              (0,helpers/* trackServerError */.qv)(data, customFormIdentifier || "", JSON.stringify(_context.t0));
              methods.setError("root.serverError", {
                type: "400"
              });

            case 10:
              if (!(!((_methods$formState$er = methods.formState.errors) !== null && _methods$formState$er !== void 0 && (_methods$formState$er2 = _methods$formState$er.root) !== null && _methods$formState$er2 !== void 0 && _methods$formState$er2.serverError) && onSubmit)) {
                _context.next = 16;
                break;
              }

              setLoading(true);
              _context.next = 14;
              return onSubmit(data);

            case 14:
              result = _context.sent;

              if (result) {
                methods.clearErrors();
                if (data.name && data.companyJobTitle) (0,helpers/* trackProgramSignupForm */.XT)(_objectSpread(_objectSpread({}, data), {}, {
                  customFormIdentifier: customFormIdentifier
                }));
                if (onSuccess) onSuccess(data);
                setNeedsAccess(false);
              } else {
                methods.setError("form", {
                  type: "server",
                  message: "user email not found"
                });
                setPrevEmail(methods.getValues("email"));
                setTimeout(function () {
                  setLoading(false);
                  setNeedsAccess(true);
                }, 50);
              }

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 6]]);
    }));

    return function submitCallback(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
      id: "get-access-form",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* FormProvider */.RV, _objectSpread(_objectSpread({}, methods), {}, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormWrapper, _objectSpread(_objectSpread({
          className: className,
          noValidate: true,
          onSubmit: methods.handleSubmit(submitCallback),
          "data-hook": "get-access-form"
        }, rest), {}, {
          children: [!methods.formState.isSubmitSuccessful && !((_methods$formState$er3 = methods.formState.errors) !== null && _methods$formState$er3 !== void 0 && (_methods$formState$er4 = _methods$formState$er3.root) !== null && _methods$formState$er4 !== void 0 && _methods$formState$er4.serverError) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormContent, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyEmail/* CompanyEmailField */.O, {}), needsAccess && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FullName/* FullNameField */.A, {}), needsAccess && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyJobTitle/* CompanyJobTitleField */.t1, {}), customFormIdentifier && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CustomFormIdentifierField */.Fe, {
              value: customFormIdentifier
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
              color: "primary",
              variant: "filled",
              size: "large",
              expanded: true,
              isLoading: isLoading,
              children: BUTTON_TEXT
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer/* default */.Z, {})]
          }), (_methods$formState$er5 = methods.formState.errors) !== null && _methods$formState$er5 !== void 0 && (_methods$formState$er6 = _methods$formState$er5.root) !== null && _methods$formState$er6 !== void 0 && _methods$formState$er6.serverError ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            role: "alert",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, _objectSpread({
              status: "error"
            }, errorMessage))
          }) : null]
        }))
      }))
    })
  });
};
/* harmony default export */ var GetAccessForm_GetAccessForm = ((/* unused pure expression or super */ null && (GetAccessForm)));
;// CONCATENATED MODULE: ../../libs/templates/Forms/GetAccessForm/index.ts


/***/ }),

/***/ 66938:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/growth-masters/sign-up",
      function () {
        return __webpack_require__(33903);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 60266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52034);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_1__);


var useCookie = function (cookieName) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () { return js_cookie__WEBPACK_IMPORTED_MODULE_1___default().get(cookieName) || null; }), value = _a[0], setValue = _a[1];
    var updateCookie = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (newValue, options) {
        js_cookie__WEBPACK_IMPORTED_MODULE_1___default().set(cookieName, newValue, options);
        setValue(newValue);
    }, [cookieName]);
    var deleteCookie = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
        js_cookie__WEBPACK_IMPORTED_MODULE_1___default().remove(cookieName);
        setValue(null);
    }, [cookieName]);
    return [value, updateCookie, deleteCookie];
};
/* harmony default export */ __webpack_exports__["Z"] = (useCookie);


/***/ }),

/***/ 60777:
/***/ (function(module) {

module.exports = "/_next/static/images/OgGrowthMasters-2a58cb594dc55ab300b61bd9183e11a0.png";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,9137,3254,9129,1382,4136,8392,2073,4488,948,3996,8726,7960,6012,9524,9833,9774,2888,179], function() { return __webpack_exec__(66938); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);